import { Button, Form, Input } from 'antd';
import React, { useEffect, useRef } from 'react';

import { Text, useTheme } from '@desygner/ui-common-components';

import { CONSTANTS } from '../../AuthModal.data';
import { StyledModalSubtitle, getPrimaryButtonStyle } from '../../AuthModal.styles';
import { AuthViewPropsT, LoginDtoT, SignupNameViewLabelsT } from '../../AuthModal.types';
import { focusInput, getServerErrorMessage, handleEnter } from '../../AuthModal.utils';
import { StepHeader } from '../../components/StepHeader/StepHeader';
import { useAuthContext } from '../../context/AuthContext';

export const SignupNameView = ({ ...props }: AuthViewPropsT) => {
  const { ...labels } = props.labels as SignupNameViewLabelsT;
  const form = Form.useFormInstance();
  const nameRef = useRef<any>(null);

  const { apiSignup } = useAuthContext();

  const { isLoading, setIsLoading, setServerError, invitationToken } = useAuthContext();

  useEffect(() => {
    focusInput(nameRef);
  }, []);

  const handleSignup = async () => {
    if (isLoading) return;

    await form
      .validateFields()

      .then(async () => {
        setIsLoading?.(true);

        const payload: LoginDtoT = {
          email: form.getFieldValue(CONSTANTS.form.emailFieldName),
          password: form.getFieldValue(CONSTANTS.form.passwordFieldName),
          first_name: form.getFieldValue(CONSTANTS.form.firstNameFieldName),
          code: form.getFieldValue(CONSTANTS.form.codeFieldName),
          marketing_communications: form.getFieldValue(CONSTANTS.form.marketingFieldName),
          invitation_token: invitationToken,
          ...(props.isDesygnerUser && {
            desygner_email: form.getFieldValue(CONSTANTS.form.emailFieldName),
          }),
        };

        await apiSignup?.(payload)
          .then((res) => {
            const token = res.data.token;

            if (!token) {
              console.error('User token is', res?.data?.token);
              setServerError?.(labels.errors.e500);
              return;
            }

            props.onLogin?.(token, 'signupName');
            props.onClose?.();
          })
          .catch((error) => {
            const serverErrorMessage = getServerErrorMessage(error) ?? labels.errors.e500;

            setServerError?.(serverErrorMessage);
            return;
          })
          .finally(() => {
            setIsLoading?.(false);
          });
      })
      .catch((error) => {
        console.error('Form validation failed.', error);
        return;
      });
  };

  const theme = useTheme();

  return (
    <>
      <StepHeader title={labels.title} onBack={() => props.onChangeView?.('signupPassword')} />

      <StyledModalSubtitle>
        <Text size="Body">{labels.subtitle}</Text>
      </StyledModalSubtitle>

      <Form.Item label={labels.form.label}>
        <Input
          ref={nameRef}
          placeholder={labels.form.placeholder}
          onKeyDown={(event) => handleEnter(event, handleSignup)}
          onChange={(event) => {
            form.setFieldValue(CONSTANTS.form.firstNameFieldName, event.target.value);
          }}
        />
      </Form.Item>
      <Button
        type="primary"
        loading={isLoading}
        onClick={handleSignup}
        style={getPrimaryButtonStyle(theme)}
        data-action="auth-signup-email"
      >
        {labels.cta.continue}
      </Button>
    </>
  );
};
